// アプリユーザ(actionのtype, reducerのstate)
// 他のMoffAPIとキーがかぶらないようにAPPUSER_をプレフィックス.
export const LOADING: string = 'APPUSER_LOADING';
export const SUCCESS: string = 'APPUSER_SUCCESS';
export const ERROR: string = 'APPUSER_ERROR';

// アプリユーザの存在確認の返り値.
export interface ResponseData {
  app_id: number;
  updated_at: string;
  created_at: string;
  unique_id: string;
  app_user_id: string;
}



// WEBPACK FOOTER //
// ./src/constants/AppUser.tsx